import { EMAIL_KIND_PRODUCTION_HANDOFF, type Project } from '@/api/client';
import { ProjectEmailModal } from './ProjectEmailModal';

export interface ProductionHandoffEmailModalProps {
  open: boolean;
  onClose: () => void;
  project: Project;
}

export function ProductionHandoffEmailModal({ open, onClose, project }: ProductionHandoffEmailModalProps) {
  return (
    <ProjectEmailModal
      open={open}
      onClose={onClose}
      project={project}
      emailKind={EMAIL_KIND_PRODUCTION_HANDOFF}
      modalTitle={`Передать в производство: ${project.name ?? 'Проект'}`}
    />
  );
}
